<template>
  <div>
    <b-table
      class="cartera-table m-0"
      head-variant="light"
      small
      hover
      responsive
      striped
      :items="data"
      :fields="columns"
      :per-page="perPage"
      :current-page="currentPage"
      @row-clicked="openCertificate"
    >
      <div slot="nro_endoso" slot-scope="data" class="text-center">{{ data.item.nro_endoso }}</div>
      <div slot="fec_emi" slot-scope="data">{{ data.item.fec_emi | date }}</div>
      <div slot="fec_vig_desde" slot-scope="data">{{ data.item.fec_vig_desde | date }}</div>
      <div slot="fec_vig_hasta" slot-scope="data">{{ data.item.fec_vig_hasta | date }}</div>
      <div slot="imp_suma_asegurada" slot-scope="data" class="text-right">{{ data.item.imp_suma_asegurada | numberFormat }}</div>
      <div slot="prima" slot-scope="data" class="text-right">{{ data.item.prima | numberFormat }}</div>
      <div slot="premio" slot-scope="data" class="text-right">{{ data.item.premio | numberFormat }}</div>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="data.length"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { currencyFormat, numberFormat } from '@/helpers/filters'
import moment from 'moment'
export default {
  props: ['data'],
  data () {
    return {
      currentPage: 1,
      perPage: 10,
      columns: [
        {
          key: 'fec_retencion',
          label: 'Fecha',
          formatter: value => moment(value).format('DD/MM/YY'),
          checked: true
        },
        {
          key: 'nro_certificado',
          label: 'Nº Cert.',
          checked: true
        },
        {
          key: 'impuesto',
          label: 'Impuesto',
          checked: true
        },
        {
          key: 'provincia',
          label: 'Jurisdiccion',
          checked: true
        },
        {
          key: 'cod_agente',
          label: 'Cod. Prod.',
          checked: true
        },
        {
          key: 'nombre_agente',
          label: 'Nombre Prod.',
          checked: true
        },
        {
          label: 'Base Imp.',
          key: 'base',
          formatter: val => currencyFormat(val),
          checked: true
        },
        {
          key: 'pje_retencion',
          label: 'Retención (%)',
          formatter: val => numberFormat(val),
          checked: true
        },
        {
          key: 'retencion',
          label: 'Retencion ($)',
          formatter: val => currencyFormat(val),
          checked: true
        }
      ]
    }
  },
  methods: {
    openCertificate (row) {
      let baseurl = 'pas/certificado-retencion-prod-pdf/'
      if (this.$role(['organizador'])) {
        baseurl = 'pas/certificado-retencion-org-pdf/'
      }

      this.$api({
        url: baseurl + row.nro_certificado + '/' + row.cod_agente,
        method: 'GET',
        responseType: 'blob',
      }).then(res => {
        const fileURL = URL.createObjectURL(res.data);
        window.open(fileURL);
      }).catch(err => {
        const toast = this.$toast;
        const fr = new FileReader();
        fr.onload = function() {
          toast.error('No se puede descargar el certificado. ' + fr.result.replace(/"/g, ''));
        };
        fr.readAsText(err.response.data);
      });

      this.sending = false;
    }
  }
}
</script>
